//bao migrate skip
import template from "./grid.html";
import * as Grid from "./grid-module";
import * as ko from "knockout";
export default {
    viewModel: {
        createViewModel: function (params, componentInfo) {
            var e = componentInfo.element;
            var vm = null;
            ko.utils.domNodeDisposal.addDisposeCallback(e, () => {
                if (vm != null) {
                    vm.dispose();
                }
            });
            vm = new Grid.GridComponent(params, componentInfo.element);
            return vm;
        }
    },
    template: template
};